module.exports = __webpack_public_path__ + "media/application/images/icons/trending-54b5f6657ca46acd888317993263538c.svg";